/**
 * @param {object} data
 * @return {{feature: string, pdf_name}}
 */
export const pdf = (data) => ({
  pdf_name: data.title,
  click: 'telechargement_pdf',
});
